import { render, staticRenderFns } from "./TabWarnings.vue?vue&type=template&id=774a26a6&scoped=true"
import script from "./TabWarnings.vue?vue&type=script&lang=js"
export * from "./TabWarnings.vue?vue&type=script&lang=js"
import style0 from "./TabWarnings.vue?vue&type=style&index=0&id=774a26a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a26a6",
  null
  
)

export default component.exports